import { Spinner } from "react-bootstrap";

export const Loader: React.FC = () => {
	return (
		<div className="loading-container mt-5">
			<Spinner animation="border" variant="primary" />
		</div>
	);
};
